import { TemplateCategoriesListItem } from '@/types/template.types';
import { Put } from '../helpers';

const ReplaceTemplatesForCategory = ({
  categoryUuid,
  templateUuids,
}: {
  categoryUuid: string;
  templateUuids: string[];
}): Promise<TemplateCategoriesListItem> => {
  return Put({
    path: `/v3/admin/templates-category-filters/categories/${categoryUuid}/events`,
    body: {
      eventUuids: templateUuids,
    },
  });
};

export default ReplaceTemplatesForCategory;
